import React from 'react'
import { forzarConfirmarArribo } from '../../../actions'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import Autorenew from '@material-ui/icons/Autorenew'
import { actualizarDatosParaMuiTable } from './actions/TablaCamionesEnPlayaActions'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'

function OperacionesCpe (props) {
  const {
    numero,
    forzarConfirmarArribo,
    actualizarDatosParaMuiTable
  } = props
  function onClick () {
    forzarConfirmarArribo(numero).then((result) => {
      console.log('Actualizando', result)
      if (result === undefined) {
        actualizarDatosParaMuiTable()
      } else {
        toast.info('CTG ya confirmado')
      }
    })
  }
  return (
    <div>
      <Tooltip title={'Forzar Confirmación de Arribo en ARCA'}>
        <IconButton onClick={() => onClick(numero)}>
          <Autorenew fontSize='default' color='primary' />
        </IconButton>
      </Tooltip>
    </div>
  )
}

const mapActionsToProps = {
  forzarConfirmarArribo,
  actualizarDatosParaMuiTable
}
const withRedux = connect(null, mapActionsToProps)

export default withRedux(OperacionesCpe)
